import { AbilityBuilder, createMongoAbility } from '@casl/ability'
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
    if (user) {
        if (user.temPermissao(['admin_juridico'])) {
            can('manage', 'ProcessoJuridico')
        }

        if (user.temPermissao(['leitura_juridico'])) {
            can('read', 'ProcessoJuridico')
        }

        can(['upload_dp'], 'ProcessoJuridico', {
            'responsavelDp.mail': { $eq: user.email },
            
        });
        
        can(['upload_seg'], 'ProcessoJuridico', {
            'responsavelSeg.mail': { $eq: user.email },
        });
    }

    return build()
}